<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="
        formData.materialId
          ? $t('images.Image Details')
          : $t('images.Create Image')
      "
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <div class="form-box">
        <el-form
          label-width="110px"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item
            v-if="editData.materialId"
            :label="$t('lcd.material.Material Name')"
            prop="materialName"
          >
            <el-input
              v-model="formData.materialName"
              placeholder=""
              clearable
              maxlength="30"
              style="width: 360px"
            />
          </el-form-item>
          <el-form-item :label="$t('images.Groups')" prop="groupId">
            <el-select
              v-model="formData.groupId"
              placeholder="请选择素材分组"
              size="small"
              style="width: 360px"
            >
              <el-option
                v-for="item in groupList"
                :key="item.codeValue"
                :label="item.codeName"
                :value="item.codeValue"
              >
                <div class="d-flex justify-content-between select-group">
                  <div>{{ item.codeName }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('itemsScenarios.ViewDialog.VisibleRange')"
            prop="openType"
            required
          >
            <el-radio-group v-model="formData.openType">
              <!-- 0  1 2 3 4  -->
              <!-- 超级管理员默认为3 -->
              <el-radio v-if="userData.userRoleId == 1" :label="3">{{ $t("lcd.material.All") }}</el-radio>
              <!-- 运维和经销商用户上传素材默认为4 -->
              <el-radio v-if="userData.userRoleId == 2 || userData.userRoleId == 3" :label="4">{{ $t("lcd.material.All") }}</el-radio>
              <el-radio :label="1">{{ $t("lcd.material.AllStore") }}</el-radio>
              <el-radio :label="0">{{ $t("lcd.material.ThisStore") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('images.Image')" prop="imageUrl">
            <video
              v-if="formData.format == 'mp4'"
              style="width: 100%; height: auto"
              :src="formData.originalUrl"
              autoplay
            ></video>
            <el-image v-else :src="formData.originalUrl"></el-image>
          </el-form-item>

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button color="#28C76F" size="small" @click="handleClose">
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="onSubmit"
              >{{ $t("button.Save") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateImage } from "@/libs/api/lcd";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口

import imagesStore from "./store/index";

let loading;

export default {
  name: "createCustomer",
  components: {},
  props: {
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      imagesStore,
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      editGroupData: {}, //编辑的分组数据
      deleteData: {},
      groupList: [],
      uploadImg: {}, //
      uploadImgsArr: [],
      initFormData: {
        materialId: "",
        materialName: "",
        groupId: "", // 素材分组
        imageUrl: "", //
        openType: 0, // 可见范围
      },
      formData: {
        materialId: "",
        groupId: "", // 素材分组
        imageUrl: "", //
        openType: 0, // 可见范围
      },
      rules: {
        materialName: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
        groupId: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.getImageGroup();
  },
  watch: {
    editData: function (val) {
      console.log("--watch--editData", val);
      if (val && val.materialId) {
        let data = {
          ...val,
          groupId: val.groupId.toString(),
        };
        this.formData = data;
      } else {
        let obj = { ...this.initFormData };
        this.formData = obj;
        this.uploadImgsArr = [];
      }
    },
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    // 获取图片分组选项
    getImageGroup() {
      console.log(123);
      const params = {
        cateId: 40,
      };
      getCodeList(params).then((res) => {
        if (res.data.code == 1) {
          this.groupList = res.data.data;
        }
      });
    },
    // 表单提交
    onSubmit() {
      loading = this.$loading({
        text: "loading...",
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单校验通过");
          this.createImage();
        } else {
          loading.close();
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 请求--- 创建素材/更新素材
    async createImage() {
      let { groupId, materialId, materialName, openType } = this.formData;
      // let userData = this.userData
      let params = {
        groupId,
        materialName,
        materialId,
        openType, //是否开放(0:所属门店可见/私有1:所属商户可见 2系统级)
      };
      let res = null;
      try {
        res = await updateImage(params);
        let response = res.data;
        if (response.code == 1) {
          this.$message.success(this.$t("commonMessage.ModifySucess"));
          this.dialogVisible = false;
          this.$emit("getData");
          loading.close();
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-create.create-image {
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 0px;
  }
  .el-select,
  .el-input--small {
    width: 82%;
    margin-right: 10px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.select-group {
  .table-icon {
    padding: 6px;
    cursor: pointer;
    font-size: 18px;
    color: #000;
  }
}
</style>